{
  "admission": "입원",
  "transfer": "전과",
  "visit": "진료",
  "type": "진료 유형",
  "status": "상태",
  "location": "위치",
  "attendingPhysician": "주치의",
  "admitDate": "입원일",
  "dischargeDate": "퇴원일",
  "chiefComplaint": "주소(主訴)",
  "diagnosis": "진단",
  "class": {
    "label": "구분",
    "values": {
      "emergency": "응급",
      "inpatient": "입원",
      "outpatient": "외래",
      "observation": "관찰",
      "ambulatory": "일일 진료",
      "homeHealth": "재택 의료",
      "virtual": "원격 진료"
    }
  },
  "statusValues": {
    "label": "상태",
    "values": {
      "pending": "대기",
      "arrived": "도착",
      "active": "진행 중",
      "completed": "완료",
      "cancelled": "취소"
    }
  },
  "admissionSource": {
    "label": "입원 경로",
    "none": "—",
    "values": {
      "emergency": "응급실",
      "clinicReferral": "외래 의뢰",
      "physicianReferral": "의사 의뢰",
      "transfer": "타 의료기관 전원",
      "self": "자가 내원 / 보행 내원",
      "courtLaw": "사법 / 법 집행 기관"
    }
  },
  "admissionType": {
    "label": "입원 유형",
    "none": "—",
    "values": {
      "elective": "예정 입원",
      "emergency": "응급",
      "urgent": "긴급",
      "newborn": "신생아",
      "trauma": "외상"
    }
  },
  "acuity": {
    "label": "중증도",
    "none": "—",
    "values": {
      "1": "1 — 소생",
      "2": "2 — 중증",
      "3": "3 — 긴급",
      "4": "4 — 준긴급",
      "5": "5 — 비응급"
    },
    "shortValues": {
      "1": "소생",
      "2": "중증",
      "3": "긴급",
      "4": "준긴급",
      "5": "비응급"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "신규 진료",
    "subtitle": "이 환자의 새로운 진료 / 입원을 시작합니다.",
    "sections": {
      "visit": "진료 정보",
      "reasonForVisit": "진료 사유",
      "admission": "입원 정보"
    },
    "fields": {
      "facility": "의료기관",
      "encounterClass": "진료 구분",
      "encounterType": "진료 유형",
      "department": "진료과",
      "attendingProvider": "주치의",
      "acuity": "중증도",
      "visitReason": "진료 사유",
      "chiefComplaint": "주소(主訴)",
      "admissionSource": "입원 경로",
      "admissionType": "입원 유형"
    },
    "placeholders": {
      "selectFacility": "의료기관을 선택하십시오",
      "none": "—",
      "encounterType": "예: 정기 검진, ER 진료",
      "visitReason": "짧은 라벨, 예: 재진, 정기 검진",
      "chiefComplaint": "환자 본인의 표현으로 작성된 사유"
    },
    "providerFallback": "의사 #{{id}}",
    "submit": "진료 생성",
    "validation": {
      "facilityRequired": "의료기관을 선택하십시오",
      "encounterClassRequired": "진료 구분을 선택하십시오"
    },
    "createdSuccess": "진료가 생성되었습니다",
    "createError": "진료 생성에 실패했습니다"
  },
  "detail": {
    "loading": "진료 정보를 불러오는 중입니다...",
    "notFound": "진료를 찾을 수 없습니다",
    "loadError": "내원 기록 로드 실패",
    "retry": "다시 시도",
    "returnToDashboard": "대시보드로 돌아가기",
    "header": {
      "title": "진료 {{number}}",
      "facilityLabel": "의료기관 #{{id}}",
      "departmentLabel": "진료과 #{{id}}",
      "locationLabel": "위치 #{{id}}",
      "admittedLabel": "입원: {{datetime}}"
    },
    "actions": {
      "transfer": "전과",
      "discharge": "퇴원"
    },
    "tabs": {
      "overview": "개요",
      "orders": "처방",
      "results": "검사 결과",
      "medications": "투약",
      "notes": "기록",
      "billing": "수납"
    },
    "overview": {
      "chiefComplaint": "주소(主訴)",
      "visitReason": "진료 사유",
      "attendingProvider": "주치의",
      "acuityLevel": "중증도",
      "providerFallback": "의사 #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "이벤트 타임라인",
      "empty": "기록된 이벤트가 없습니다",
      "admittedTitle": "입원",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "주소(主訴) 없음",
      "orderTitle": "처방: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "결과: {{type}}"
    },
    "orders": {
      "title": "처방",
      "newOrder": "+ 신규 처방",
      "empty": "이 진료에 대한 처방이 없습니다",
      "metaLine": "{{number}} | {{type}} | 우선순위: {{priority}}"
    },
    "results": {
      "title": "검사 결과",
      "empty": "이 진료에 대한 결과가 없습니다",
      "criticalBadge": "위험",
      "viewLink": "보기",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "투약",
      "newMedication": "+ 신규 투약",
      "empty": "이 진료에 대한 투약이 없습니다",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "임상 기록 모듈은 곧 제공됩니다",
      "goToClinicalNotes": "임상 기록으로 이동"
    },
    "billing": {
      "comingSoon": "수납 모듈은 곧 제공됩니다"
    }
  },
  "census": {
    "title": "병상 보드 / 재원 명단",
    "subtitle": "실시간 병상 점유 및 환자 재원 현황",
    "refresh": "새로고침",
    "facilityName": "싱가포르 종합병원",
    "capacitySummary": "사용 중 {{occupied}} / 총 {{total}} 병상",
    "occupancyLabel": "점유율 {{percent}}%",
    "stats": {
      "totalCapacity": "총 병상",
      "occupied": "사용 중",
      "available": "이용 가능",
      "pendingDischarge": "퇴원 예정"
    },
    "unitFilter": {
      "all": "전체 병동",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "내과 / 외과",
      "obs": "관찰실",
      "peds": "소아과",
      "maternity": "산과"
    },
    "roleView": {
      "nurse": "간호사 보기",
      "physician": "의사 보기",
      "bedManager": "병상 관리자 보기"
    },
    "viewMode": {
      "grid": "그리드 보기",
      "table": "표 보기"
    },
    "loading": "재원 데이터를 불러오는 중입니다...",
    "columns": {
      "patient": "환자",
      "mrn": "MRN",
      "admitDate": "입원일",
      "status": "상태",
      "acuity": "중증도",
      "isolation": "격리",
      "fallRisk": "낙상 위험",
      "codeStatus": "소생 방침",
      "chiefComplaint": "주소(主訴)",
      "attending": "주치의",
      "los": "LOS",
      "locationBed": "위치 / 병상",
      "transferStatus": "전과 상태",
      "expectedDischarge": "예상 퇴원",
      "actions": "작업"
    },
    "values": {
      "unknownPatient": "알 수 없음",
      "none": "없음",
      "notAvailable": "N/A",
      "pending": "대기",
      "empty": "--",
      "providerFallback": "의사 #{{id}}",
      "locationLabel": "위치 #{{id}}",
      "losDays": "{{days}}일"
    },
    "codeStatusTooltip": "소생 방침은 환자 차트에서 확인할 수 있습니다",
    "actionsMenu": {
      "label": "작업",
      "viewChart": "차트 보기",
      "transfer": "전과",
      "assignAttending": "주치의 지정",
      "discharge": "퇴원"
    },
    "empty": "재원 중인 진료가 없습니다",
    "department": {
      "filteredTo": "{{name}}만 표시 중",
      "idLabel": "부서 {{id}}",
      "showAll": "모든 부서 표시"
    },
    "facility": {
      "label": "시설",
      "allFacilities": "모든 시설",
      "idLabel": "시설 {{id}}"
    }
  },
  "discharge": {
    "label": "퇴원",
    "title": "퇴원 워크플로",
    "encounterLabel": "진료 {{number}}",
    "printButton": "퇴원 기록 인쇄",
    "loading": "진료 정보를 불러오는 중...",
    "notFound": "진료를 찾을 수 없습니다",
    "returnToDashboard": "대시보드로 돌아가기",
    "notActive": "해당 진료는 진행 중이 아닙니다(현재 상태: {{status}})",
    "backToEncounter": "진료 페이지로 돌아가기",
    "progress": {
      "requiredMissingTooltip": "필수 항목이 누락되었습니다",
      "tasksRemainingTooltip": "남은 작업이 있습니다"
    },
    "steps": {
      "summary": "퇴원 요약",
      "medications": "약물",
      "followup": "추적 관찰",
      "instructions": "퇴원 안내",
      "nursing": "간호 업무",
      "signoff": "주치의 서명",
      "review": "검토 및 확정"
    },
    "summary": {
      "title": "퇴원 요약",
      "diagnosisLabel": "퇴원 진단 *",
      "diagnosisPlaceholder": "퇴원 진단을 입력하세요...",
      "diagnosisCodeLabel": "퇴원 진단 코드(ICD-10)",
      "diagnosisCodePlaceholder": "ICD-10 코드 검색...",
      "proceduresLabel": "시행 시술",
      "proceduresPlaceholder": "이번 진료에서 시행한 시술을 나열하세요...",
      "conditionLabel": "퇴원 시 상태 *"
    },
    "condition": {
      "values": {
        "stable": "안정",
        "improved": "호전",
        "unchanged": "변화 없음",
        "worsened": "악화",
        "critical": "위중"
      }
    },
    "medications": {
      "title": "퇴원 약물",
      "instructions": "각 약물에 대해 지속, 중단, 변경 중 하나를 선택하세요.",
      "actions": {
        "continue": "지속",
        "stop": "중단",
        "modify": "변경"
      },
      "modifiedPlaceholder": "변경된 복약 지시를 입력하세요...",
      "empty": "이 진료에 활성 약물이 없습니다"
    },
    "medAction": {
      "values": {
        "continue": "지속",
        "stop": "중단",
        "modify": "변경"
      }
    },
    "followup": {
      "title": "추적 관찰 예약",
      "providerLabel": "추적 관찰 의사",
      "providerPlaceholder": "의사 이름 또는 진료과...",
      "dateLabel": "추적 관찰 일자",
      "notesLabel": "추가 메모",
      "notesPlaceholder": "추적 관찰 관련 메모..."
    },
    "instructions": {
      "title": "환자 안내",
      "generalLabel": "일반 안내",
      "generalPlaceholder": "환자에게 안내할 일반적인 퇴원 지침...",
      "dietaryLabel": "식이 안내",
      "dietaryPlaceholder": "식이 제한 또는 권고 사항...",
      "activityLabel": "활동 제한",
      "activityPlaceholder": "신체 활동 제한 사항...",
      "warningSignsLabel": "주의해야 할 증상",
      "warningSignsPlaceholder": "다음 증상이 나타나면 즉시 재방문하거나 진료받도록 안내하세요..."
    },
    "nursing": {
      "title": "간호 업무",
      "instructions": "퇴원 전 아래 체크리스트를 완료하세요. 이 항목은 기록용이며 API를 호출하지 않습니다.",
      "tasks": {
        "removeIv": "IV 라인 제거",
        "discontinueMonitoring": "모니터링 장비 해제",
        "patientEducation": "환자 교육 완료",
        "medsReviewed": "환자와 퇴원 약물 확인 완료",
        "belongingsReturned": "환자 소지품 반환",
        "transportArranged": "퇴원 이동 수단 준비"
      }
    },
    "signoff": {
      "title": "주치의 서명",
      "instructions": "아래 퇴원 요약을 검토한 후 주치의 서명을 진행하세요.",
      "diagnosisHeading": "퇴원 진단",
      "notProvided": "미입력",
      "medicationsHeading": "퇴원 약물",
      "noMedications": "확인할 약물이 없습니다",
      "signedCompleted": "주치의 서명이 완료되었습니다.",
      "signAsAttending": "주치의로 서명",
      "requiresAttendingSignoff": "주치의 서명이 필요합니다"
    },
    "review": {
      "title": "퇴원 검토 및 확정",
      "summaryHeading": "퇴원 요약",
      "fields": {
        "diagnosis": "진단:",
        "procedures": "시술:",
        "condition": "상태:",
        "provider": "의사:",
        "date": "일자:",
        "notes": "메모:",
        "general": "일반:",
        "diet": "식이:",
        "activity": "활동:",
        "warningSigns": "주의 증상:"
      },
      "medicationsHeading": "약물 조정",
      "noMedications": "확인할 약물이 없습니다",
      "followupHeading": "추적 관찰",
      "instructionsHeading": "환자 안내",
      "noInstructions": "안내 사항이 입력되지 않았습니다",
      "pendingOrdersWarning": "미완료 처방 또는 미서명 기록이 있을 수 있습니다. 퇴원 완료 전에 확인하세요.",
      "diagnosisRequired": "퇴원을 완료하려면 퇴원 진단이 필요합니다.",
      "empty": "--"
    },
    "nav": {
      "previous": "이전",
      "next": "다음",
      "complete": "퇴원 완료"
    },
    "toast": {
      "success": "환자가 성공적으로 퇴원했습니다",
      "error": "퇴원 처리에 실패했습니다"
    }
  },
  "components": {
    "transferDialog": {
      "title": "내원 전동",
      "description": "환자를 시설 내 다른 위치로 이동합니다.",
      "targetLocationLabel": "전동 대상 위치",
      "loadingLocations": "위치를 불러오는 중…",
      "selectLocation": "위치를 선택하세요",
      "emptyState": "이 시설에 다른 활성 위치가 없습니다.",
      "reasonLabel": "사유",
      "reasonPlaceholder": "예: 격리 필요, ICU 단계 강하, 더 높은 관찰 강도 침상",
      "actions": {
        "transfer": "전동"
      },
      "toasts": {
        "success": "내원이 전동되었습니다",
        "error": "내원 전동에 실패했습니다"
      }
    },
    "assignAttendingDialog": {
      "title": "주치의 지정",
      "description": "이 내원을 담당할 주치의를 설정합니다.",
      "providerLabel": "주치의",
      "loadingProviders": "의사를 불러오는 중…",
      "selectProvider": "의사 선택",
      "emptyState": "이 시설에 근무 중인 의사가 없습니다.",
      "actions": {
        "assign": "지정"
      },
      "toasts": {
        "success": "주치의가 지정되었습니다",
        "error": "주치의를 지정하지 못했습니다"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "사용 가능",
        "occupied": "사용 중",
        "reserved": "예약",
        "cleaning": "청소 중",
        "closed": "폐쇄",
        "isolated": "격리",
        "contaminated": "오염됨"
      },
      "acuityLegendLabel": "ESI 응급도:",
      "empty": "구성된 병동이 없습니다",
      "summary": {
        "available_one": "사용 가능 {{count}}",
        "available_other": "사용 가능 {{count}}",
        "occupied_one": "사용 중 {{count}}",
        "occupied_other": "사용 중 {{count}}",
        "reserved_one": "예약 {{count}}",
        "reserved_other": "예약 {{count}}",
        "cleaning_one": "청소 중 {{count}}",
        "cleaning_other": "청소 중 {{count}}",
        "closed_one": "폐쇄 {{count}}",
        "closed_other": "폐쇄 {{count}}",
        "isolated_one": "격리 {{count}}",
        "isolated_other": "격리 {{count}}",
        "contaminated_one": "오염됨 {{count}}",
        "contaminated_other": "오염됨 {{count}}"
      }
    },
    "protocolPanel": {
      "title": "프로토콜 등록",
      "enroll": "등록",
      "availableProtocols": "사용 가능한 프로토콜",
      "loadingProtocols": "프로토콜 불러오는 중...",
      "noProtocols": "사용 가능한 프로토콜이 없습니다",
      "stepBadge": "단계 {{current}}/{{total}}",
      "loadingEnrollments": "등록 불러오는 중...",
      "noEnrollments": "활성 프로토콜 등록이 없습니다",
      "completeStep": "단계 완료",
      "toasts": {
        "enrollSuccess": "프로토콜에 등록되었습니다",
        "enrollError": "프로토콜 등록에 실패했습니다",
        "advanceSuccess": "단계가 완료되었습니다",
        "advanceError": "단계 진행에 실패했습니다"
      }
    }
  }
}
